import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import moment from "moment-with-locales-es6";
import { Box, Text } from "@chakra-ui/react";
import { ShowCompactEvents } from "../ShowCompactEvents";

export const SimpleSlider = ({ eventsSlider }) => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 1,
    arrows: false,
    slidesToScroll: 1,
  };

  const settings2 = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    draggable: false,
    slidesToScroll: 1,
  };

  const monthName = [];
  const monthId = [];

  eventsSlider.forEach((value, key) => {
    monthName.push(moment.months(key));
    monthId.push(key);
  });

  return (
    <Slider {...settings}>
      {monthName.map(function (value, key) {
        return (
          <Box key={key}>
            <Text
              fontFamily={"Sofia Pro"}
              fontSize={"13px"}
              fontWeight={400}
              align={"left"}
              letterSpacing={0.1}
            >
              Au cours du mois{" "}
              {["octobre", "avril", "aout"].includes(value) ? "d’" : "de "}
              {value}, vous avez organisé
            </Text>
            <Text
              fontFamily={"Sofia Pro"}
              fontSize={"36px"}
              fontWeight={900}
              align={"left"}
              lineHeight={0.85}
            >
              {eventsSlider.get(monthId[key])[0]
                ? eventsSlider.get(monthId[key])[0].length > 1
                  ? `${eventsSlider.get(monthId[key])[0].length} événements`
                  : `${eventsSlider.get(monthId[key])[0].length} événement`
                : ""}
            </Text>
            <Box
              bg="white"
              boxShadow={"lg"}
              w="80%"
              borderRadius={"20px"}
              my={"20px"}
            >
              <Slider {...settings2}>
                {eventsSlider.get(monthId[key])[0].map(function (value, key) {
                  return (
                    <div key={key}>
                      <ShowCompactEvents event={value}></ShowCompactEvents>
                    </div>
                  );
                })}
              </Slider>
            </Box>
          </Box>
        );
      })}
    </Slider>
  );
};

export default SimpleSlider;
